/* eslint-disable */
import { TextField } from '@mui/material';
import { get } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { modalActions, productActions } from '../../../Actions';
import { modalTypes } from '../../../Constants';
import { BaseModal } from '../BaseModal';
import { ProductVariantsListItem } from './ProductVariantsListItem';
import styles from './ProductVariantsModal.module.scss';
import { alterProductForSalesUnitConsumptionLogic, isEmpty, isSalesUnitConsumptionLogicTrue } from '@/Helpers';

const HEADING = 'Select a variant';
const initialState = {
	multiSelect: {
		productId: [],
		variantId: [],
	},
	default: {
		productId: null,
		variantId: null,
	},
};
const ProductVariantsModal = (props) => {
	// eslint-disable-next-line object-curly-newline
	const {
		toggleModal,
		fetchProducts,
		groups,
		salesUnitAsUnitForRecipe = false,
		multiSelect,
		activeProduct = null,
		excludeProductIds = false,
		modalMode = 'PRODUCT_VARIANTS',
		isAccompaniment = false,
	} = props;

	const modalTypesConstants = ['PRODUCT_VARIANTS', 'PRODUCT_ACCOMPANIMENTS'];
	const MODAL_TYPE = modalTypesConstants.includes(modalMode) ? modalTypes[modalMode] : modalMode;
	const { show, data } = useSelector((state) => state.modal?.[MODAL_TYPE] || {});
	const products = useSelector((state) => state.product.products);

	const { groupId = null, itemTypes = ['PRODUCT'] } = data || {};
	const [searchQuery, setSearchQuery] = useState('');

	useEffect(() => {
		if (isEmpty(products) && !isAccompaniment) {
			fetchProducts();
		}
	}, []);

	const [state, setState] = useState(() => {
		return initialState[multiSelect ? 'multiSelect' : 'default'];
	});

	const handleClose = () => {
		setState({
			...initialState[multiSelect ? 'multiSelect' : 'default'],
		});
		toggleModal(MODAL_TYPE, false);
		setSearchQuery('');
	};

	const addVariant = (productId, variantId) => {
		if (multiSelect) {
			// check if the state already has the variant; deselect it
			if (
				state.productId === productId &&
				state.variantId === variantId
			) {
				setState({
					...state,
					productId: [],
					variantId: [],
				});
				// else set the variant in state and select it
			} else {
				setState({
					...state,
					productId: [...state.productId, productId],
					variantId: [...state.variantId, variantId],
				});
			}
			return;
		}

		// check if the state already has the variant; deselect it
		if (state.productId === productId && state.variantId === variantId) {
			setState({
				...state,
				productId: null,
				variantId: null,
			});
			// else set the variant in state and select it
		} else {
			setState({
				...state,
				productId,
				variantId,
			});
		}
	};

	const handleConfirm = () => {
		const { productId, variantId } = state;
		if (
			productId != null ||
			(Array.isArray(productId) && productId?.length !== 0)
		) {
			let selectedProduct = products?.[productId];
			if (isSalesUnitConsumptionLogicTrue(selectedProduct)) {
				selectedProduct = alterProductForSalesUnitConsumptionLogic(selectedProduct);
			}
			const selectedVariant =
				selectedProduct?.ProductVariant?.[variantId];
			const variantObj = {
				productId,
				variantId,
				default: false,
				additionalPrice: 0,
				price: selectedVariant?.cost,
				groupId,
			};

			props.handleConfirm(variantObj);
		}
		handleClose();
	};

	const filteredMemoizedProducts = useMemo(() => {
		return Object.keys?.(products ?? {})?.filter?.((id) => {
			const product = products[id];
			if (excludeProductIds) {
				if (activeProduct && Number(activeProduct) !== Number(id)) {
					return (
						itemTypes.indexOf(product.skuType) !== -1 &&
						product?.productName
							?.toLowerCase()
							?.includes(searchQuery?.toLowerCase())
					);
				}
			} else {
				return (
					itemTypes.indexOf(product.skuType) !== -1 &&
					product?.productName
						?.toLowerCase()
						?.includes(searchQuery?.toLowerCase())
				);
			}
		});
	}, [products, itemTypes, searchQuery, activeProduct]);

	const generateList = () => {
		return filteredMemoizedProducts?.map((id) => {
			const product = products[id];
			if (salesUnitAsUnitForRecipe && isSalesUnitConsumptionLogicTrue(product)) {
				const newProduct = alterProductForSalesUnitConsumptionLogic(product);
				return (
					<ProductVariantsListItem
						product={newProduct}
						choices={get(groups, [groupId, 'choices'])}
						key={id}
						handleClick={addVariant}
						selection={state}
					/>
				);
			}
			return (
				<ProductVariantsListItem
					product={product}
					choices={get(groups, [groupId, 'choices'])}
					key={id}
					handleClick={addVariant}
					selection={state}
				/>
			);
		});
	};

	return (
		// eslint-disable-next-line react/jsx-boolean-value
		<BaseModal
			heading={HEADING}
			open={show}
			handleClose={handleClose}
			handleConfirm={handleConfirm}
			width='50rem'
		>
			<div className={`${styles.root}`}>
				<TextField
					fullWidth
					value={searchQuery}
					onChange={(e) => {
						setSearchQuery(e?.target?.value);
					}}
					placeholder='Search'
				/>
				<div className='flex overflow-x-hidden flex-1 flex-col gap-2 overflow-y-auto'>
					{generateList()}
					{filteredMemoizedProducts.length === 0 && (
						<p>No Items to display</p>
					)}
				</div>
			</div>
		</BaseModal>
	);
};

ProductVariantsModal.defaultProps = {
	multiSelect: false,
};


const mapDispatchToProps = {
	toggleModal: modalActions.toggleModal,
	fetchProducts: productActions.fetchProducts,
};

export default connect(
	null,
	mapDispatchToProps
)(ProductVariantsModal);
